import styled, { css } from 'styled-components';

export const TextOverflow = styled.span`
  ${({ subject, theme }) => (subject) && css`
    color: ${theme.colorStyled.ColorTextOrange};
    font-size: 1em;
    overflow-wrap: break-word;
    line-height: 1.1em;
    display: block;
    overflow: hidden;
  }`}
  ${({ subject, large }) => (subject&&large) && css`
    font-size: 1.3em;
    margin: 0;
    padding: 0;
    white-space: normal;
  }`}
  ${({ decreaseFontSize }) => decreaseFontSize && css`
    font-size: 1em;
  `}
`
